import React from 'react';
import { CLASSNAME_PREFIX } from '../../componentConfig';
import iconWarning from '../../images/exclamation_mark.svg';
import './AddressVerificationFailed.scss';

export var AddressVerificationFailed = function AddressVerificationFailed(_ref) {
  var content = _ref.content;

  return React.createElement(
    'div',
    { className: CLASSNAME_PREFIX + '-address-verification-failed__container' },
    React.createElement(
      'div',
      { className: CLASSNAME_PREFIX + '-address-verification-failed__info-wrapper' },
      React.createElement('img', { src: iconWarning, className: CLASSNAME_PREFIX + '-address-verification-failed__info-icon' }),
      React.createElement(
        'h2',
        { className: CLASSNAME_PREFIX + '-address-verification-failed__info-title' },
        content.address_update_failed_title
      ),
      React.createElement('div', {
        className: CLASSNAME_PREFIX + '-address-verification-failed__info-text',
        dangerouslySetInnerHTML: { __html: content.address_update_failed_text }
      })
    ),
    content.address_update_failed_upload_button_url && React.createElement(
      'a',
      {
        href: content.address_update_failed_upload_button_url,
        className: CLASSNAME_PREFIX + '-address-verification-failed__upload-button',
        target: '_blank',
        rel: 'noopener noreferrer'
      },
      content.address_update_failed_upload_button_text
    )
  );
};